import { baseApi } from './base.api';

export const reportApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getChartData: build.query({
      query: ({ ts, ...payload }) => ({
        url: '/v1/reports/analytics/chart',
        method: 'POST',
        body: payload,
      }),
    }),
    getDailyReport: build.query({
      query: ({ ts, ...payload }) => ({
        url: '/v1/reports/analytics',
        method: 'POST',
        body: payload,
      }),
      transformResponse: ({ data: rows = [], count = 0 }) => ({
        rows,
        count,
      }),
    }),
    getBalancesReport: build.query({
      query: ({ ts, ...payload }) => ({
        url: '/v1/reports/balances',
        method: 'POST',
        body: payload,
      }),
      transformResponse: ({ data: rows = [], count = 0 }) => ({
        rows,
        count,
      }),
    }),
    getBalancesReportTotals: build.query({
      query: ({ ts, ...payload }) => ({
        url: '/v1/reports/balances/totals',
        method: 'POST',
        body: payload,
      }),
    }),
    downloadBalancesReport: build.mutation({
      query: ({ ts, ...payload }) => ({
        url: '/v1/reports/balances/download',
        method: 'POST',
        body: payload,
        responseHandler: (res) => res.blob(),
      }),
    }),
    downloadReport: build.mutation({
      query: ({ ts, ...payload }) => ({
        url: '/v1/reports/analytics/download',
        method: 'POST',
        body: payload,
        responseHandler: (res) => res.blob(),
      }),
    }),
  }),
});

export const {
  useGetChartDataQuery,
  useGetDailyReportQuery,
  useGetBalancesReportQuery,
  useGetBalancesReportTotalsQuery,
  useDownloadBalancesReportMutation,
  useDownloadReportMutation,
} = reportApi;
